import type { RouteRecordRaw } from 'vue-router';

const EmptyLayout = () => import('@/shared/layouts/pages/EmptyLayout/index.vue');
const Transaction = () => import('@/modules/transaction/pages/TransactionFlow/index.vue');

const transactionRoutes: Array<RouteRecordRaw> = [
  {
    path: '/transaction',
    name: 'transaction',
    redirect: {
      name: 'transaction-index',
    },
    meta: {
      accessRol: {
        section: 'TRANSACTIONS',
        actions: ['P2P_SEND', 'INDIVIDUAL_SEND', 'MULTI_SEND'],
      },
    },
    component: EmptyLayout,
    children: [
      {
        path: '',
        name: 'transaction-index',
        component: Transaction,
      },
      {
        path: '/transaction/:routeId',
        name: 'transaction-with-params',
        component: Transaction,
      },
    ],
  },
];

export default transactionRoutes;
